import { NextApiRequest } from 'next';
import parserUA from 'ua-parser-js';

import { MAX_MOBILE_WIDTH, MAX_TABLET_WIDTH } from '../constants';

export const isMobile = (context?: { isMobile?: boolean }): boolean =>
  context?.isMobile ||
  (typeof window !== 'undefined' && window.innerWidth <= MAX_MOBILE_WIDTH);

export const isMobileSSR = (req?: NextApiRequest) => {
  const ua = parserUA(req ? req.headers['user-agent'] : navigator.userAgent);
  return ua.device.type === 'mobile';
};

export const isTabletSSR = (req?: NextApiRequest) => {
  const ua = parserUA(req ? req.headers['user-agent'] : navigator.userAgent);
  return ua.device.type === 'tablet';
};

export const isTablet = (context?: { isTablet?: boolean }): boolean =>
  context?.isTablet ||
  (typeof window !== 'undefined' &&
    window.innerWidth > MAX_MOBILE_WIDTH &&
    window.innerWidth < MAX_TABLET_WIDTH);

export const isSledUserAgent = (userAgent?: string) =>
  (userAgent || navigator.userAgent).includes('AdamIsTheChaosMonkey');
